import type { ReportCampaignOption } from '../types/reports';

/** API may nest the campaign list under `data`, `data.data`, or `data.campaigns`. */
export function normalizeCampaignOptions(payload: unknown): ReportCampaignOption[] {
  const root = (payload as { data?: unknown } | undefined)?.data;
  if (Array.isArray(root)) return root as ReportCampaignOption[];
  const nested = root as { data?: unknown; campaigns?: unknown } | undefined;
  if (Array.isArray(nested?.data)) return nested.data as ReportCampaignOption[];
  if (Array.isArray(nested?.campaigns)) return nested.campaigns as ReportCampaignOption[];
  return [];
}

export function getCampaignOptionId(option: ReportCampaignOption): string {
  return String(option._id || option.id || option.campaignId || '');
}

export function getCampaignOptionName(option: ReportCampaignOption): string {
  return String(option.campaignName || option.name || 'Untitled campaign');
}

export const THEME_COLOR_OPTIONS: Array<{ value: string; label: string; swatch: string }> = [
  { value: 'BLUE', label: 'Blue', swatch: '#3B82F6' },
  { value: 'RED', label: 'Red', swatch: '#EF4444' },
  { value: 'GREEN', label: 'Green', swatch: '#10B981' },
  { value: 'DARK', label: 'Dark', swatch: '#1F2937' },
];

export function getThemeSwatch(themeColor?: string): string {
  const match = THEME_COLOR_OPTIONS.find(
    (opt) => opt.value.toLowerCase() === (themeColor || '').toLowerCase(),
  );
  return match?.swatch || '#CBD5E1';
}

export function fmtReportDate(value?: string) {
  if (!value) return 'Never';
  return new Date(value).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
